// Copyright © 2021 Move Closer
import { defineComponent } from '@vue/composition-api';
import { useCheckControl } from '../../_abstract';
import { BootstrapFormError } from '../FormError';
import { bootstrapCheckSizeRegistry } from './Check.config';
import { bootstrapCheckProps } from './Check.hooks';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const BootstrapCheck = defineComponent({
    name: 'BootstrapCheck',
    components: { FormError: BootstrapFormError },
    props: bootstrapCheckProps,
    setup(props, ctx) {
        const { checked, hasErrors, sizeClass, checkType, validationClass, collapse } = useCheckControl(props, ctx, bootstrapCheckSizeRegistry);
        function composeKey(iteration, prefix) {
            const key = typeof prefix === 'string' ? prefix : props.name;
            return `${key}-${iteration}`;
        }
        return { checked, composeKey, hasErrors, sizeClass, checkType, validationClass, collapse };
    },
    template: `
    <div>
      <!-- Options -->
      <div v-for="(option, i) in options" :key="composeKey(i, option.name)"
           class="form-check" :class="[className, sizeClass, validationClass]" >

        <!-- Input (mainly for the a11y purposes) -->
        <input :type="checkType" :id="composeKey(i, option.name)"
               :value="option" v-model="checked"
               v-bind="{ disabled, name, readonly, required }"
               :class="'form-check__control form-control ' + validationClass">

        <!-- Label (renders actual input with ::before and ::after pseudo-elements) -->
        <label :for="composeKey(i, option.name)" :class="{'form-check__collapse': collapse.isCollapsed(composeKey(i, option.name))}"
               class="form-check__label form-label">
          <span v-html="option.label"></span>
          <span v-if="required" class="form-label__asterisk">&nbsp;*</span>
        </label>
        <a v-if="option.readMore" class="form-check__read-more" href="javascript:void(0)"
           @click="collapse.toggleCollapse(composeKey(i, option.name))">
          <template v-if="collapse.isCollapsed(composeKey(i, option.name))">
            {{ $t('_.expand') }}
          </template>
          <template v-else>
            {{ $t('_.collapse') }}
          </template>
        </a>

      </div>
      <!-- END | Options -->

      <!-- Validation errors -->
      <FormError v-for="error in errors" :key="$id(error)">
        {{ error }}
      </FormError>
    </div>
  `
});
